import React from 'react'
import {
  ApproachSelect,
  AudienceSelect,
  Button,
  ButtonOutline,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  IssueSelect,
  TagAdder,
  // VisibilitySelector,
} from '../../../components'
import { useHistory, Link } from 'react-router-dom'
import { ProgressBar } from '.'
import { ExportPopup } from './export-popup/index'
import { TagProvider } from '../../../features/tag/hook/provider'
import { SystemProvider } from '../../../features/system/provider'
import dayjs from 'dayjs'
import 'dayjs/locale/id'
import { SidebarStatus } from './sidebar-status'
import service from '../../../features/event/service'
import { toast } from 'react-toastify'
import { submissionStatus, activityStatus } from '../../../constants'
import SidebarCancel from './sidebar-cancel'
import { useInternationalization } from '../../../features/i18n'
import { useViewport } from '../../../utils'
import FieldPopup from '../../../components/popup/field'
import FieldPopupContent from './field-popup-content'
import { useSelector } from 'react-redux'

const Sidebar = ({requesting, updateForm, isEdit, handleSubmit}) => {
  const form = useSelector(state => state.eventForm.data)
  const { isDesktop } = useViewport()
  const [poppedUp, setPoppedUp] = React.useState(false)
  const history = useHistory()
  const { translate, language } = useInternationalization()
  const [showFieldPopup, setShowFieldPopup] = React.useState(false)

  const {
    registration_end_date,
    guest_seat,
    guest_total,
    registrationType,
    suitable,
    approach,
    issue,
    tags,
    image,
    id,
    status_activity_id
  } = form

  const isNotCancelled = status_activity_id !== activityStatus.cancelled

  const handleImage = (e) => {
    if (e) {
      console.log(e)

      const name = e.name
      const type = e.type
      const blob = URL.createObjectURL(e)

      updateForm({
        target: {
          name: 'new_image',
          value: {name, type, blob}
        }
      })
    }
  }

  const handleDelete = () => {
    let c = window.confirm('Apakah anda yakin akan menghapus konten ini?')
    if(c){
      service.delete(id)
        .then(res => {
          console.log(res)
          toast.success('Event successfully deleted!')
          history.push('/dashboard/events')
        })
        .catch(err => {
          console.log(err)
          toast.error('Error.')
        })
    }
  }

  const handleDraft = (e) => {
    console.log('save as draft')
    e.preventDefault()
    e.stopPropagation()

    handleSubmit({submission: submissionStatus.draft})
  }

  const handleDownload = () => {
    setShowFieldPopup(true)
  }

  return (
    <div>
      {
        isDesktop &&
        <div className="p-5 rounded mb-8" style={{background: '#f5f5f5'}}>
          {
            registrationType === 'internal' &&
            <div>
              <ProgressBar progress={guest_total} total={guest_seat} />
              <p className="text-sm text-gray-444">
                {translate('EVENT', 'guest_total')}: {guest_total}/{guest_seat}
              </p>
              <div className="flex items-center mb-4">
                <p className="text-sm text-primary underline mr-1">
                  <Link to={`/dashboard/events/${id}/guest-list`}>
                    {translate('EVENT', 'view_guests')}
                  </Link>
                </p>
              </div>
            </div>
          }

          <SidebarStatus isEdit={isEdit}/>

          {
            registrationType === 'internal' &&
            <p className="text-sm text-gray-444 mb-5">
              {translate('EVENT', 'registration_end_date')}: <br/>
              {/* Aug/20/2020 */}
              {
                language.name === 'en' ? dayjs(registration_end_date).format('MMM/DD/YYYY') : dayjs(registration_end_date).locale('id').format('DD MMMM YYYY')
              }
            </p>
          }

          <Button className="mb-3"
            disabled={requesting}
            isLoading={requesting}
          >
            {translate('GENERAL', 'submit')}
          </Button>

          <ButtonOutline
            transparent
            outlineColor="primary"
            className="text-primary uppercase font-accent py-4"
            disabled={requesting}
            isLoading={requesting}
            onClick={handleDraft}
          >
            {translate('GENERAL', 'save_to_draft')}
          </ButtonOutline>

          { (isEdit && isNotCancelled) && <SidebarCancel handleSubmit={handleSubmit}/> }

          {
            isEdit && <>
              {/* <Link className="block link text-sm pt-4" to={`/event/${id}/detail`}>
                View Event
              </Link> */}

              <div
                className="mt-5 text-center text-xs text-gray-500 underline cursor-pointer"
                onClick={handleDelete}
              >
                {translate('GENERAL', 'delete')}
              </div>
            </>
          }
        </div>
      }

      <div className="mb-5 lg:mb-10">
        <ImagePickerSidebar
          label={translate('GENERAL', 'poster_image')}
          defaultValue={image}
          onChange={handleImage}
        />
      </div>

      <SystemProvider>
        <div className="mb-5 lg:mb-10">
          <AudienceSelect defaultValues={suitable} updateForm={updateForm}/>
        </div>

        <div className="mb-5 lg:mb-10">
          <ApproachSelect
            defaultValues={approach}
            updateForm={updateForm}
          />
        </div>

        <div className="mb-5 lg:mb-10">
          <IssueSelect
            defaultValues={issue}
            updateForm={updateForm}
          />
        </div>
      </SystemProvider>

      <TagProvider>
        <div className="mb-8 lg:mb-10">
          <Label>Tag</Label>
          <TagAdder
            data={tags}
            onChange={(value) => {
              updateForm({
                target: {
                  name: 'tags',
                  value
                }
              })
            }}
          />
        </div>
      </TagProvider>

      {
        (registrationType === 'internal' &&
        isDesktop) && <>
          <div className="mb-4">
            <ButtonOutline
              transparent
              outlineColor="primary"
              className="text-primary uppercase font-accent py-4"
              type="button"
              onClick={handleDownload}
            >
              {translate('GENERAL', 'download_report')}
            </ButtonOutline>
          </div>
          <div className="mb-10">
            <ButtonOutline
              type="button"
              outlineColor="primary"
              className="text-primary uppercase font-accent py-4"
              onClick={() => setPoppedUp(true)}
            >
              {translate('EVENT', 'export_to_program')}
            </ButtonOutline>
          </div>
        </>
      }
      {
        poppedUp &&
        <ExportPopup onClose={() => setPoppedUp(false)}/>
      }
      {
        !isDesktop &&
        <div className="mb-8">
          <Button thin className="mb-3">
            {translate('GENERAL', 'submit')}
          </Button>
          <ButtonOutline
            transparent
            outlineColor="primary"
            className="text-primary uppercase font-accent"
            onClick={handleDraft}
          >
            {translate('GENERAL', 'save_to_draft')}
          </ButtonOutline>
          {
            registrationType === 'internal' &&
            <div>
              <hr className="my-5"/>
              <ButtonOutline
                type="button"
                outlineColor="primary"
                className="text-primary uppercase font-accent mb-3"
                onClick={handleDownload}
              >
                {translate('GENERAL', 'download_report')}
              </ButtonOutline>
              <ButtonOutline
                type="button"
                outlineColor="primary"
                className="text-primary uppercase font-accent"
                onClick={() => setPoppedUp(true)}
              >
                {translate('EVENT', 'export_to_program')}
              </ButtonOutline>
            </div>
          }
        </div>
      }
      {
        showFieldPopup &&
        <FieldPopup onClose={() => setShowFieldPopup(false)}>
          <FieldPopupContent />
        </FieldPopup>
      }
    </div>
  )
}

export { Sidebar }
